/* ============================================================
   MOSAIK — CART  (maps the current design to Shopify line items)
   ============================================================ */
Object.assign(window.mosaik, {
  addToCart: async function(){
    const mosaik = this;
            const recap = mosaik._lastRecap;
            const items = [];
            const handled = {
              top:    false,
              bottom: false,
              left:   false,
              right:  false
            };
            Object.values(recap.tiles).forEach(v => {
                items.push({ id: v.id, quantity: v.count });
            });
            // borders: group by type and collect sides
            const borderMap = {};
            Object.values(mosaik.borderAssignments).forEach(bo => {
                const key = bo['name_' + mosaik.options.lang];
                if (!borderMap[key]) {
                borderMap[key] = { fId: bo.fId, mId: bo.mId, count: 0, color : bo.color, side: new Set() };
                }
                borderMap[key].count++;
                borderMap[key].side.add(bo.side);
            });
            Object.values(borderMap).forEach(entry => {
                const oppositeTopBottom = entry.side.has('top') && entry.side.has('bottom');
                const oppositeLeftRight = entry.side.has('left') && entry.side.has('right');
                const leftOrRight = !oppositeLeftRight && (entry.side.has('left') || entry.side.has('right'));
                const topOrBottom = !oppositeTopBottom && (entry.side.has('top') || entry.side.has('bottom'));
                let idToUse;
                if(oppositeTopBottom){
                  if(entry.side.has('top')){
                    items.push({ id: entry.mId, quantity: mosaik.countBordersBySide('bottom', entry.color) });
                    items.push({ id: entry.fId, quantity: mosaik.countBordersBySide('top', entry.color) });
                    handled.bottom = true;
                    handled.top = true;
                  }
                }
                if(oppositeLeftRight){
                    if(entry.side.has('right')){
                      items.push({ id: entry.mId, quantity: mosaik.countBordersBySide('left', entry.color) });
                      items.push({ id: entry.fId, quantity: mosaik.countBordersBySide('right', entry.color) });
                      handled.left = true;
                      handled.right = true;
                    }
                }
                if(topOrBottom || leftOrRight ){
                    const sideSet = entry.side;
                    let side;
                    let idToUse;
                    if(sideSet.has("top") && !handled.top){
                      side = "top";
                      idToUse = entry.mId;
                      handled.bottom = true;
                    }else if(sideSet.has("bottom") && !handled.bottom){
                      side = "bottom";
                      handled.top = true;
                      idToUse = entry.mId;
                    }else if(sideSet.has("left") && !handled.left){
                      side = "left";
                      handled.right = true;
                      idToUse = entry.mId;
                    }else if(sideSet.has("right") && !handled.right){
                      side = "right";
                      handled.left = true;
                      idToUse = entry.mId;
                    }
                    else{
                      idToUse = entry.fId;
                    }
                    if(sideSet.size=== 1 && !handled.bottom && !handled.top && !handled.left && !handled.right){
                      idToUse = entry.fId
                    }
          
                    const existIndex = items.findIndex(item => item.id === idToUse);
                    if (existIndex !== -1) {
                      items[existIndex].quantity += mosaik.countBordersBySide(side, entry.color);
                    }else{
                    items.push({ id: idToUse, quantity: entry.count });
                    }


                }
            });
            // corners
            Object.values(recap.corners).forEach(c => {
                items.push({ id: c.obj.id, quantity: c.count });
            });
            // feature layers
            if(window.MosaikLights && MosaikLights.enabled) MosaikLights.addCartItems(mosaik, items);
            if(window.MosaikObjects && MosaikObjects.enabled) MosaikObjects.addCartItems(mosaik, items);
            try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items })
            });
            if (!res.ok) throw await res.json();
            // Fired before the redirect: MosaikStats uses sendBeacon, which is
            // the only transport guaranteed to survive the page unload.
            if (window.MosaikStats) MosaikStats.track('add_to_cart', { lineItems: items.length });
            window.location.href = '/cart';
            } catch (err) {
            console.error(err);
            alert('Erreur lors de l’ajout au panier.');
        }
  }
});
